import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { get } from 'lodash'
import { safelyUpdateCartItemQuantity } from '../actions/cart'
import { makeGetCartItemByIndex } from '../selectors/cart'

import QuantityEntryModal from '../components/QuantityEntryModal'

const mapStateToProps = (state, ownProps) => {
  const getCartItemByIndex = makeGetCartItemByIndex()
  const cartItemIndex = get(ownProps, 'match.params.cartItemIndex', -1)

  const cartItem = getCartItemByIndex(state, cartItemIndex)
  const oldQuantity = get(cartItem, 'quantity', 1)

  return { oldQuantity }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const cartItemIndex = get(ownProps, 'match.params.cartItemIndex', -1)

  return {
    updateCartItemQuantity: (quantity) => {
      dispatch(safelyUpdateCartItemQuantity({ index: cartItemIndex, quantity }))
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuantityEntryModal))
